<script setup lang="ts">
import { computed, ref } from 'vue'

// Preview and print controls for one version. The preview is the server's
// rendered page (the same renderer the public URL uses) in a same-origin
// iframe; print opens it in a new tab with the on-load print call.
const props = defineProps<{ versionId: number; isDraft: boolean }>()

const open = ref(false)

const BUTTON_CLASS =
  'min-h-11 rounded-lg border border-border-control px-3 text-[13px] text-ink hover:bg-surface-hover sm:min-h-9'

const previewUrl = computed(() => `/api/v1/cv_versions/${props.versionId}/preview`)

function print(): void {
  window.open(`${previewUrl.value}?print=1`, '_blank', 'noopener')
}
</script>

<template>
  <div class="flex flex-col gap-3" data-testid="cv-preview">
    <div class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        :class="BUTTON_CLASS"
        :aria-expanded="open"
        data-testid="cv-preview-toggle"
        @click="open = !open"
      >
        {{ open ? 'Hide preview' : 'Preview' }}
      </button>
      <button type="button" :class="BUTTON_CLASS" data-testid="cv-print" @click="print">Print / Save as PDF</button>
      <span v-if="isDraft" class="text-xs text-ink-faint">Preview and print use the last saved draft.</span>
    </div>
    <iframe
      v-if="open"
      :src="previewUrl"
      title="CV preview"
      class="h-[70vh] min-h-[600px] w-full rounded-xl border border-border-subtle bg-white"
      data-testid="cv-preview-frame"
    />
  </div>
</template>
